import { useState } from "react";
import { useAppDispatch } from "../../../../redux-store";
import {
  deleteClientCargoTemplate,
  renameClientCargoTemplate,
} from "../../../../ducks/data/client-order-templates";
import GenericPromptDialog from "../../GenericPromptDialog/GenericPromptDialog";
import {
  DeleteOutlinedCrossIconButton,
  EditIconButton,
  OpenIconButton,
} from "../../../buttons";
import "./ClientCargoTemplateRow.scss";
import { useStableNavigate } from "../../../StableNavigateContext";
import ClientCargoTemplateSelectNameDialog from "./ClientCargoTemplateSelectNameDialog";
import { useTranslation } from "react-i18next";

const ClientCargoTemplateRow = ({
  template,
  clientId,
  showOpenButton,
}: {
  template: { id: string; name: string };
  clientId: string;
  showOpenButton?: boolean;
}) => {
  const [shouldShowRenameDialog, setShowRenameDialog] = useState(false);
  const [shouldShowDeleteDialog, setShowDeleteDialog] = useState(false);
  const [reqInProgress, setReqInProgress] = useState(false);
  const navigate = useStableNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation(["orderTemplates", "components"]);

  const onConfirmDelete = () => {
    setReqInProgress(true);
    dispatch(deleteClientCargoTemplate(template.id))
      .unwrap()
      .then(() => setShowDeleteDialog(false))
      .catch(() => {
        // The deleteClientCargoTemplate thunk has already reported it and shown the error toast;
        // re-enable the dialog so the user can retry.
        setReqInProgress(false);
      });
  };

  const onConfirmRename = (name: string) => {
    dispatch(
      renameClientCargoTemplate({
        clientId,
        templateId: template.id,
        name,
      })
    )
      .unwrap()
      .then(() => setShowRenameDialog(false))
      .catch(() => {
        // The renameClientCargoTemplate thunk has already reported it and shown the error toast.
      });
  };

  const onEditTemplateClick = () => {
    navigate({
      hash: `clientCargoTemplate=${template.id}&clientId=${clientId}`,
    });
  };

  return (
    <>
      {shouldShowDeleteDialog && (
        <GenericPromptDialog
          title={t("orderTemplates:deleteModal.title")}
          onCancelClick={() => setShowDeleteDialog(false)}
          onContinueClick={onConfirmDelete}
          text={t("orderTemplates:deleteModal.text")}
          continueButtonColor={"error"}
          continueText={t("components:buttonLabels.delete")}
        />
      )}
      {shouldShowRenameDialog && (
        <ClientCargoTemplateSelectNameDialog
          onClose={() => setShowRenameDialog(false)}
          clientId={clientId}
          onSubmit={onConfirmRename}
          existingTemplateToRename={template}
          buttonsDisabled={reqInProgress}
        />
      )}
      <div key={template.id} className="client-cargo-template-row">
        <div>{template.name}</div>
        <div className="client-cargo-template-row__buttons">
          {showOpenButton && (
            <OpenIconButton onClick={onEditTemplateClick}>
              text={t("orderTemplates:editButton")}
            </OpenIconButton>
          )}
          <EditIconButton
            onClick={() => setShowRenameDialog(true)}
          ></EditIconButton>
          <DeleteOutlinedCrossIconButton
            onClick={() => setShowDeleteDialog(true)}
          />
        </div>
      </div>
    </>
  );
};

export default ClientCargoTemplateRow;
